<template>
  <section class="bottomBtnBox">
    <van-action-bar safe-area-inset-bottom>
      <van-row class="fc bottomBtnRow">
        <van-col span="6">
          <van-action-bar-icon v-show="showService" icon="chat-o" text="客服" @click="toService" />
        </van-col>
        <van-col span="6" :class="{ hidden: !isEnterShoppingCar }">
          <van-action-bar-icon icon="cart-o" text="购物车" :badge="shoppingCarCount ? shoppingCarCount : ''" @click="bugFn('toShoppingCar')" />
        </van-col>
        <van-col span="6" :class="{ hidden: !isEnterShoppingCar }" @click="bugFn('addShoppingCar')">
          <van-action-bar-button
            :disabled="!isEnable"
            :class="{ disabled: !isEnable, addShoppingCar: isEnable }"
            color="#3088c5"
            type="warning"
            text="加入购物车"
          />
        </van-col>
        <van-col span="6" @click="bugFn('bugNow')">
          <van-action-bar-button :disabled="!isEnable" :class="{ disabled: !isEnable }" color="#3088c5" type="danger" text="立即购买" />
        </van-col>
      </van-row>
    </van-action-bar>
  </section>
  <slot><ConfirmGoods :datas="detailData" :brandInfo="brandInfo" :showPopUp="showNum" :from="from" :currentType="currentType"/></slot>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import ConfirmGoods from '@/components/common/ConfirmGoods'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { getRobotUrl } from '@/util/index'

export default {
  components: {
    ConfirmGoods
  },
  emits: ['toShoppingCar', 'clickGoodBtn'],
  props: ['detailData', 'isEnterShoppingCar', 'isEnable', 'from', 'brandInfo'],
  setup(props, { emit }) {
    let store = useStore()
    const route = useRoute()
    let { isEnterShoppingCar, isEnable, from, brandInfo } = toRefs(props)
    const state = reactive({
      showNum: 0,
      currentType: '',
      isEnterShoppingCar,
      isEnable, // 计划是否生效中，生效中才可以购买 ,生效中--true
      from,
      brandInfo
    })
    const shoppingCarCount = computed(() => store.state.shoppingCarCount || 0)
    const showService = computed(() => route.path === '/tyreDetail')
    const bugFn = val => {
      console.log(val)
      if ((val === 'bugNow' || val === 'addShoppingCar') && !state.isEnable) return
      if (val == 'toShoppingCar') {
        emit(val, val)
        emit('clickGoodBtn', { type: val, from: state.from })
        return
      }
      state.currentType = val
      state.showNum += 1
      emit('clickGoodBtn', { type: val, from: state.from })
    }
    const toService = () => {
      let robotUrls = getRobotUrl(store)
      // console.log('robotUrls---', robotUrls)
      if (robotUrls) {
        window.location.href = robotUrls
      }
    }
    return {
      ...toRefs(state),
      bugFn,
      shoppingCarCount,
      showService,
      toService
    }
  }
}
</script>

<style lang="scss" scoped>
// 底部按钮区域
.bottomBtnBox {
  height: 48px;
  padding-top: 10px;
  background-color: #f5f5f5;
  .bottomBtnRow {
    width: 100%;
    height: 50px;
  }
  .van-col {
    height: 50px;
  }
  .van-button {
    border-radius: 0;
    height: 50px;
  }
  .van-action-bar-button--first {
    margin-left: 0;
  }
  .unable {
    opacity: 0.5;
  }
}
:deep(.van-action-bar) {
  z-index: 1;
}
.hidden {
  visibility: hidden;
}
.disabled {
  background-color: #aaa !important;
  border-left: 1px solid #fff !important;
}
.addShoppingCar {
  opacity: 0.8;
}
</style>
